// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w1HR","label":"styles_label__7kZpb"};